import React from "react";
import { createUseStyles } from "react-jss";
import { EditableInput } from "react-color/lib/components/common";
const useStyles = createUseStyles({
  field: { paddingLeft: "6px", width: "100%" },
  alpha: { paddingLeft: "6px", width: "100%" },
});

export const RGBFields = ({ rgb, hsl, style, onChange }) => {
  const handleChange = (data, e) => {
    const hasRgbInput =
      data.r !== undefined || data.g !== undefined || data.b !== undefined;

    if (hasRgbInput) {
      onChange(
        {
          r: data.r === undefined || data.r === "" ? rgb.r : data.r,
          g: data.g === undefined || data.g === "" ? rgb.g : data.g,
          b: data.b === undefined || data.b === "" ? rgb.b : data.b,
          source: "rgb",
        },
        e
      );
    } else if (data.a !== undefined) {
      const parsedAlpha = Number(data.a);
      if (!Number.isFinite(parsedAlpha)) {
        return;
      }

      const clampedAlpha = Math.max(0, Math.min(1, parsedAlpha));

      onChange(
        {
          h: hsl.h,
          s: hsl.s,
          l: hsl.l,
          a: Math.round(clampedAlpha * 100) / 100,
          source: "rgb",
        },
        e
      );
    }
  };
  const classes = useStyles();
  return (
    <>
      <div className={classes.field}>
        <EditableInput
          style={style}
          label="r"
          value={rgb.r}
          onChange={handleChange}
        />
      </div>
      <div className={classes.field}>
        <EditableInput
          style={style}
          label="g"
          value={rgb.g}
          onChange={handleChange}
        />
      </div>
      <div className={classes.field}>
        <EditableInput
          style={style}
          label="b"
          value={rgb.b}
          onChange={handleChange}
        />
      </div>
      <div className={classes.alpha}>
        <EditableInput
          style={style}
          label="a"
          value={rgb.a}
          arrowOffset={0.01}
          onChange={handleChange}
        />
      </div>
    </>
  );
};
